import { render, staticRenderFns } from "./ProdutoDetalhes.vue?vue&type=template&id=d6582cb2&scoped=true"
import script from "./ProdutoDetalhes.vue?vue&type=script&lang=js"
export * from "./ProdutoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ProdutoDetalhes.vue?vue&type=style&index=0&id=d6582cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6582cb2",
  null
  
)

export default component.exports